module.exports = __webpack_public_path__ + "static/media/img-13.5194cbfa.png";